<template>
  <div>
    <confirm-date-modal
      v-if="confirmDate"
      @close="confirmDate = false"
      @save="saveUpdatedPhoto"
      :show="confirmDate"
      :loading="loading"
    />
    <transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container p-0">
          <div class="modal-body p-0 mb-0 border-top border-primary border-3x">
            <div class="modal-content-test">
              <div  class="zoom-box">
                <div class="zoom-out">
                  <button id="zoom-out" @click="zoomOut">
                    <img class="img-responsive" src="@/assets/images/minus-zoom.png" alt="shap">
                  </button>
                </div>
                <div class="zoom-input">
                  <input type="range"  v-model="zoomRange" id="zoom-input-in-editor" min="1" max="2000" step="4" class="slider">
                </div>
                <div class="zoom-in">
                  <button id="zoom-in" @click="zoomIn">
                    <img class="img-responsive" src="@/assets/images/plus-zoom.png" alt="shap">
                  </button>
                </div>
              </div>
              <!--        Image Editor Component -->
              <tui-image-editor ref="tuiImageEditor"  :options="options" />
              <div class="save-image-btns">
                <button class="btn btn-danger btn-sm btn-save-image" type="button" @click="$parent.showModal = false">
                     Abbrechen
                </button>
                <button class="btn btn-primary btn-sm btn-save-image" :disabled="loading" @click="saveEditedImage">
                 <span v-if="loading" class="spinner-border  pr-1 spinner-border-sm" role="status">
                    <span class="sr-only">Loading...</span>
                 </span>  Speichern
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
  </div>
</template>
<script>
import ImageEditor from '@toast-ui/vue-image-editor/src/ImageEditor.vue'
import "tui-color-picker/dist/tui-color-picker.css"
import '../../../assets/css/image-editor.css'
import {fabric} from 'fabric'
import md5 from 'js-md5'
import axios from '../../../utils/axiosinstance'
// import axios from 'axios'
import moment from 'moment'
import ConfirmDateModal from "../ConfirmDateModal";
export default {
  props: ['show'],
  created() {
    const width = document.body.offsetWidth;
    if (width < 1550){
      this.options.cssMaxHeight = 600;
    }else {
      this.options.cssMaxHeight = 800;
    }
  },
  components: {
    ConfirmDateModal,
    'tui-image-editor': ImageEditor
  },
  data(){
    return {
      panning: false,
      photo : null,
      loading: false,
      confirmDate: false,
      isDraw: true,
      canvas: null,
      zoomRange: 1,
      updatedPhoto: "",
      index: 'index',
      activePhoto: null,
      useDefaultUI: true,
      offset_left: 0,
      offset_top: 0,
      h_dif: 0,
      w_dif: 0,
      options: {
        usageStatistics: false,
        cssMaxWidth: 1300,
        cssMaxHeight: 800,
        uiSize: {
          width: '1300px',
          maxHeight: '800px'
        },
        includeUI: {
          loadImage: {
            path: require('@/assets/images/Logo.png'),
            name: 'SampleImage',
          },
          initMenu: 'icon',
          menuBarPosition: 'top',
          locale: {
            "Apply": 'Anwenden',
            "Arrow": 'Pfeil 1',
            "Arrow-2": 'Pfeil 2',
            "Arrow-3": 'Pfeil 3',
            Blend: "Mischen",
            Blur: "Unschärfe",
            Bold: "Fett",
            Italic: "Kursiv",
            Brightness: "Helligkeit",
            Bubble: "Sprechblase",
            Cancel: "Abbrechen",
            Center: "Zentriert",
            Circle: "Kreis",
            Color: "Farbe",
            "Color Filter": "Farbfilter",
            Crop: "Zuschneiden",
            Custom: "Individuell",
            "Custom icon": 'Eigenes Icon',
            Delete: "Löschen",
            "Delete-all": "Alles löschen",
            Distance: "Wert",
            Draw: "Zeichnen",
            Emboss: "Prägung",
            Fill: "Hintergrund",
            Filter: "Filter",
            Flip: "Spiegeln",
            "Flip X": "Vertikal",
            "Flip Y": "Horizontal",
            Free: "Frei",
            Grayscale: "Graustufen",
            Heart: "Herz",
            Invert: "Invertieren",
            "Load Mask Image": 'Maske importieren',
            Location: "Standort",
            Left: "Links",
            Mask: "Maske",
            Multiply: "Multiplizieren",
            Noise: "Rauschen",
            Pixelate: "Verpixeln",
            Range: "Wert",
            Rectangle: "Rechteck",
            "Remove White":"Weiß entfernen",
            "Reset": "Zurücksetzen",
            Rotate:"Drehen",
            Right:"Rechts",
            Shape: "Form",
            Sharpen: "Schärfen",
            Square: "Quadrat",
            "Star-1": "Stern 1",
            "Star-2": "Stern 2",
            Straight: "Linie",
            Stroke: "Rahmen",
            Threshold: "Wert",
            Tint: "Tönen",
            Triangle: "Dreieck",
            Underline: "Unterstrichhen",
            "Text size": "Schriftgröße"
          }
        },
      },
    }
  },

  methods: {
    async getLargeImage (photo) {
      $('.spinner-cover').show();
      console.log('GetLargeImage', photo)
      let _this = this
      _this.loading = true
      _this.activePhoto = photo
      let url = `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${photo.pdprojectid}&id=${photo.pdphotoid}&type=l&token=${localStorage.sessiontoken}`
      await fetch(url, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid
          }
        }).then(response => response.blob())
        .then(response => {
          $('.spinner-cover').hide();
          let reader = new FileReader();
          reader.readAsDataURL(response);
          reader.onload = function() {
            _this.$refs.tuiImageEditor.invoke('loadImageFromURL', reader.result, 'edited image').then(res => {
              _this.canvas = _this.$refs.tuiImageEditor.invoke('_graphics.getCanvas');
              _this.addEventsOnCanvas(_this.canvas);
              // _this.setCanvasBackgroundImage(fotos , _this.canvas)
            });
          }
        });
      _this.loading = false
    },

    addEventsOnCanvas (canvas) {
      canvas.set({
        selection: false,
        controlsAboveOverlay: true,
        centeredScaling: true,
        allowTouchScrolling: true,
        hasBorders: false,
        lockRotation: false,
        lockMovement: false,
        lockMovementY: false,
        lockMovementX: false,
        lockUniScaling: false,
        lockScalingY: false,
        lockScalingX: false,
        originX: 'middle',
        originY: 'middle',
        preserveObjectStacking: false,
        pointDragTrue: false,
      })

      let _this = this
      canvas.on('mouse:wheel', function (opt) {
        _this.pointBox = false
        if (opt.e.deltaY > 0) {
          _this.zoomOut()
        } else {
          _this.zoomIn()
        }
      })

      canvas.on('mouse:up', function (e) {
        _this.panning = false
      })

      canvas.on('mouse:down', function (e) {
        _this.panning = true
      })
      canvas.on('object:moving', function (e) {
        _this.panning = false
      })
      canvas.on('object:scaling', function (e) {
        _this.panning = false
      })
      canvas.on('object:scaled', function (e) {
        _this.panning = true
      })
      canvas.on('object:rotating', function (e) {
        _this.panning = false
      })
      canvas.on('object:rotated', function (e) {
        _this.panning = true
      })
      canvas.on('object:added', function (e) {
        _this.panning = false
      })
      canvas.on('object:created', function (e) {
        _this.panning = false
      });

       // On drawing start and end
      _this.setPanning();

      canvas.on('mouse:move', function (e) {
        if (_this.panning && e && e.e) {
          if (this.pointDragTrue === false && _this.isDraw) {
            let delta = new fabric.Point(e.e.movementX, e.e.movementY)
            canvas.relativePan(delta)
            let canvasViewPort = canvas.viewportTransform

            let bottomEndPoint = canvas.height * (canvasViewPort[0] - 1)
            if (canvasViewPort[5] >= 0 || -bottomEndPoint > canvasViewPort[5]) {
              canvasViewPort[5] = (canvasViewPort[5] >= 0) ? 0 : -bottomEndPoint
            }
            let rightEndPoint = canvas.width * (canvasViewPort[0] - 1)
            if (canvasViewPort[4] >= 0 || -rightEndPoint > canvasViewPort[4]) {
              canvasViewPort[4] = (canvasViewPort[4] >= 0) ? 0 : -rightEndPoint
            }
          }
        }
      })
      canvas.renderAll();
    },

     //Save Image after drawing completed
     saveEditedImage() {
      this.$parent.showModal = false;
      this.confirmDate = true;
      this.updatedPhoto = this.$refs.tuiImageEditor.invoke('toDataURL')
    },
    saveUpdatedPhoto(data){
      this.loading = true
      this.getImageQuality(this.updatedPhoto,data)
    },

    /**Check image quality before upload
     *
     *
     */
    async getImageQuality(file,data) {
      let md5_hash = md5(file);
        let params = {
            'methodName': 'getPhotoQualities',
            'parameters': [this.$route.params.id, [md5_hash]],
            'serviceName': 'ProjectdocuService'
          }
        await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}addfile_fileexists/&token=${localStorage.sessiontoken}`,
          params,
          {
            headers: {
              apitoken: localStorage.apikey,
              deviceid: localStorage.deviceid,
              accept: 'application/json'
            }
          }).then(response => {
            if (response.data.versions[md5_hash].quality == 'missing'){
              this.setFormData(file , md5_hash,data)
            }
           }).catch(e => {
              console.log(e);
          })
      this.loading = false
      },

    //Set form data for upload image
    setFormData(base64_img , hash,data){
      this.loading = true
      // let photo_date = this.activePhoto.photodate ? new Date(this.activePhoto.photodate.substr(0,10)) : new Date();
      let basephotodate = this.activePhoto.photodate
      let photo_date = this.activePhoto.photodate ? new Date(this.activePhoto.photodate) : new Date();
      let date
      console.log('ImageSetFormData', data)
      if (data.type === 'other_date'){
        photo_date = data.date
        console.log('Selected Date: photo_date: ', photo_date)
        date = moment(photo_date).set({hour: '12', minute: '00', second: '00'}).format('YYYY-MM-DD HH:mm:ss')
      } else {
        console.log('Selected Date: this.activePhoto.photodate: ', this.activePhoto.photodate)
        date = this.activePhoto.photodate
        // date = moment(this.activePhoto.photodate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
        // date = moment(photo_date).format('YYYY-MM-DD HH:mm:ss')
      }
      const date_for_filename = moment(photo_date).format('DD.MM.YYYY HH:mm')
      const file_name = this.activePhoto.origname;
      let new_filename = file_name.replace('.jpg', '')
      new_filename = new_filename.replace('.JPG', '')
      const form_data = new FormData();
      form_data.append('quality','original')
      form_data.append('Filename',`drawing-${new_filename}.jpg`)
      form_data.append('photodate',date)
      form_data.append('exifgpsx','0')
      form_data.append('exifgpsy','0')
      form_data.append('exifdate',date)
      form_data.append('exif','')
      form_data.append('Upload','Start')
      form_data.append('hash', hash)
      form_data.append('copy_tags', data.copy_tags)
      form_data.append('copy_flag', data.copy_flag)
      form_data.append('copy_desc', data.copy_desc)
      form_data.append('src_photoid', this.activePhoto.pdphotoid)
      //convert base-64 to binary
      fetch(base64_img).then(res => res.blob()).then(blob => {
        form_data.append('Filedata',blob)
        //finally upload the edited Image
        this.uploadImage(form_data);
      })
    },


    /**Upload image method
     *
     * @param data
     * @returns {Promise<void>}
     */
   async uploadImage(data){

      this.loading = true
     let _this = this
      await axios.post(`${process.env.VUE_APP_BASE_URL}backend/put?method=img&projectid=${this.$route.params.id}&type=addfile_photo&token=${localStorage.sessiontoken}`,
        data, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          },
        }).then(res => {
        if (res.statusText === "OK" || res.status == 200){
          _this.$toast.success("Foto gespeichert")
          _this.$parent.showModal = false
          _this.$store.commit('refreshPhotosListByEdit');
        }
      }).catch(error => {
        _this.$toast.error(`Oops ... ${error}`)
      });
      this.confirmDate = this.loading = false
    },

    /**
     * Method for zoom out canvas
     */
    zoomOut () {
      if (this.zoomRange >= 1) {
        this.zoomRange = (Math.floor(this.zoomRange)) - (4)
      }
    },


    /**
     * Method for zoom in canvas
     */
    zoomIn () {
      if (this.zoomRange < 2000) {
        this.zoomRange = (Math.floor(this.zoomRange)) + (4)
      }
    },
    /**
     * Set panning on / off for while drawing by mouse
     */
    setPanning(){
      let _this = this
      $('.tie-btn-draw.tui-image-editor-item.normal').click(function (){
        _this.isDraw = !($('.tie-btn-draw.tui-image-editor-item.normal').hasClass('active'))
      })
    },
    nextImage () {
      if (this.$store.state.photo.dirty) {
        return
      }
      if (this.index == this.photos.length - 1)
        this.index = 0
      else {
        this.index += 1
      }
      this.getLargeImage(this.photos[this.index])
    },
    prevImage () {
      if (this.$store.state.photo.dirty) {
        return
      }
      this.index -= 1
      this.getLargeImage(this.photos[this.index])
    }
  },

  watch: {
    zoomRange: function (range) {
      let canvas = this.canvas
      let c = (range / 55) + 1
      canvas.zoomToPoint({x: canvas.getWidth() / 2, y: canvas.getHeight() / 2}, c)
      canvas.setZoom(c);
    },
    show: function (val){
      if (val){
        document.querySelector('body').style.overflowY = 'hidden'
      }else {
        document.querySelector('body').style.overflowY = 'auto'
      }
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 98%;
  height: 100%;
  margin: 0 auto;
  padding: 10px 20px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 10px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal.show .modal-dialog{
  width: 98%;
  min-height: 100%;
}
.save-image-btns{
  z-index: 99;
  bottom: 10px;
  right: 26px;
  font-weight: 500;
  position: absolute;
}
.btn.btn-save-image{
  line-height: 2.6;
}
.zoom-box {
  width: 245px;
  height: 36px;
  top: 14px;
  left: 20px;
  z-index: 99;
}

.btn.btn-next{
  z-index: 99;
  top: 47%;
  right: 40px;
  padding-right: 17px;
  padding-left: 18px;
  font-size: 1.7rem;
}
.btn.btn-prev{
  z-index: 99;
  top: 47%;
  left: 40px;
  padding-right: 18px;
  padding-left: 15px;
  font-size: 1.7rem;
}
</style>
<style>
.tui-image-editor-container{
  min-height: calc(100vh - 20px) !important;
  max-height: 98vh !important;
}
.tui-image-editor-controls-logo{
   visibility: hidden !important;
}
.tie-mask-apply.tui-image-editor-newline.apply{
  display: none !important;
}
.tui-image-editor-container .tui-image-editor-wrap .tui-image-editor-size-wrap .tui-image-editor-align-wrap {
  display: table-cell;
  vertical-align: top;
}
/*.tui-image-editor{*/
/*  height: 80vh !important;*/
/*  width: 52% !important;*/
/*}*/
[data-icontype="icon-star"],[data-icontype="icon-star-2"],[data-icontype="icon-arrow-3"],[data-icontype="icon-heart"],[data-icontype="icon-polygon"]{
  display: none !important;
}
.tui-image-editor-container .tui-image-editor-submenu .tui-image-editor-submenu-item .tui-image-editor-button.cancel label {
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/components/photo/components/PhotoEditorModal.vue